import React from "react";
import "../styles/Footer.css";
import { Link } from "react-router-dom";
import logo from "../logo.svg";

const Footer = () => {
  return (
    <div className="footer-section">
      <footer className="footer">
        <Link to="/" className="footer-brand">
          <img src={logo} alt="DoctorBach" />
          <h2>Noninvasive Ventilatory Support</h2>
        </Link>
        <div className="mission">
          <p>
            "Empowering respiratory care through safe, effective noninvasive
            ventilation — supporting clinicians, patients, and better outcomes
            every breath of the way."
          </p>
        </div>
        <div className="footer-links">
          <div>
            <Link to="/ourcenters">Our Centers</Link>
            <Link to="/drbach">Dr. Bach</Link>
            <Link to="/Resources" className="link">
              Resources
            </Link>
            <Link to="/About" className="link">
              About
            </Link>
          </div>
        </div>

        <div className="footer-note">
          <p>&copy; 2025 DoctorBach.com. All rights reserved.</p>
          <p>
            Developed by:{" "}
            <Link
              to="https://www.linkedin.com/in/sikandermohammad/"
              style={{
                textDecoration: "none",
                color: "white",
                paddingTop: "20px",
              }}
            >
              Sikander Mohammad
            </Link>
          </p>
        </div>
      </footer>
    </div>
  );
};

export default Footer;
